// Youtube IFrame API
var tag = document.createElement('script');
tag.src = "https://www.youtube.com/iframe_api";
var firstScriptTag = document.getElementsByTagName('script')[0];
firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

// Global namespace
var App = App || {},
Player  = Player || {};

App.mfp = {
  init: function() {

    var $mfpHeliShot = $('.js-modal-iframe');

    $mfpHeliShot.magnificPopup({
      type: 'iframe',
      iframe: {
        markup: '<div class="mfp-iframe-scaler">'+
        '<div class="mfp-close"></div>'+
        '<iframe id="player" class="mfp-iframe" frameborder="0" allowfullscreen></iframe>'+
        '</div>', // HTML markup of popup, `mfp-close` will be replaced by the close button
        patterns: {
          youtube: {
            index: 'youtube.com',
            id: 'v=',
            src: '//www.youtube.com/embed/%id%?rel=0&enablejsapi=1'
          }
        }
      },
      callbacks: {
        open: function () {

        /**
         * [onPlayerReady description]
         * @param  {[type]} event [description]
         * @return {[type]}       [description]
         */
        function onPlayerReady(event) {
          event.target.mute();
          event.target.playVideo();
        }

        Player = new YT.Player('player', {
          events: {
            'onReady': onPlayerReady
          }
        });

        }
      },
      closeBtnInside: false,
      closeOnContentClick: true
    });

  }
}

export default App